"use client";
import useAxiosAuth from "@/lib/hooks/useAxiosAuth";
import {useRouter} from "next/navigation";
import * as yup from "yup";
import {Form, FormField, FormMessage} from "@/components/ui/form";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import {useState} from "react";
import CWFTextarea from "@/components/ui/CWFTextarea";
import CWFButton from "@/components/ui/CWFButton";
import toast from "react-hot-toast";

const REQUIRED_ERROR = "Ce champs est requis";
const commentSchema = yup.object({
   comment : yup.string().required(REQUIRED_ERROR)
});
export default function CommentForm({postId, commentId = false}){
    const axios = useAxiosAuth();
    const router = useRouter();
    const [loading, setLoading] = useState(false);

    const commentForm = useForm({
        resolver : yupResolver(commentSchema)
    });

    function postComment(data){
        if(commentId){
            data = {...data, comment_id : commentId};
        }
        axios.post(`comments/${postId}`, data)
            .then(() => toast.success("Commentaire posté"))
            .catch(() => toast.error("Une erreur est survenue"))
            .finally(() => {
                commentForm.reset();
                router.refresh();
            })
    }

    return(
        <Form {...commentForm}>
            <form className={"grid gap-2"} onSubmit={commentForm.handleSubmit(postComment)}>
                <CWFTextarea name={"comment"} control={commentForm.control} label={"Commentaire"}/>
                <div className={"flex justify-end"}>
                    <CWFButton loading={loading}>Commenter</CWFButton>
                </div>
            </form>
        </Form>
    )

}